import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { zigbeeNodeSave } from '../../../actions/zigbee/commands/Node/ZigbeeNodeSave';
export const ZigbeeNodeInfo = (props) => {
    var _a, _b;
    const dispatch = useAppDispatch();
    const node = useAppSelector(state => state.definitions.zigbee_nodes[props.node_id]);
    const [title, setTitle] = React.useState((_a = node === null || node === void 0 ? void 0 : node.title) !== null && _a !== void 0 ? _a : '');
    const [comment, setComment] = React.useState((_b = node === null || node === void 0 ? void 0 : node.comment) !== null && _b !== void 0 ? _b : '');
    const onChange = event => {
        setTitle(event.target.value);
    };
    const onChangeComment = event => {
        setComment(event.target.value);
    };
    const onSubmit = event => {
        event.preventDefault();
        dispatch(zigbeeNodeSave(props.node_id, { title, comment }));
    };
    if (node == undefined) {
        return null;
    }
    const nwk = node.nwk == null ? '?' : '0x' + node.nwk.toString(16).padStart(4, '0');
    // old versions don't have ieee_hex. we can phase out usage of node.ieee after a while
    const ieee = node.ieee_hex != null ? node.ieee_hex : (node.ieee == null ? null : (node.ieee.toString(16).padStart(16, '0')));
    const ieeeStr = ieee == null ? '?' : ('0x' + ieee);
    const last_seen = new Date(node.last_seen).toLocaleString();
    return (_jsxs("div", { children: [_jsxs("div", { children: ["NWK=", nwk, " IEEE=", ieeeStr, " Last seen=", last_seen] }), _jsx("br", {}), _jsx("form", { onSubmit: onSubmit, children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '10px' }, children: [_jsx("div", { style: { flex: '0 1 auto' }, children: _jsxs("label", { children: ["Title", _jsx("br", {}), _jsx("input", { type: "text", size: 30, value: title, onChange: onChange })] }) }), _jsx("div", { style: { flex: '1 1 auto' }, children: _jsxs("label", { children: ["Comment", _jsx("br", {}), _jsx("textarea", { value: comment, cols: 30, onChange: onChangeComment, style: {} })] }) }), _jsx("div", { style: { alignSelf: 'end', flex: '0 0 auto' }, children: _jsx("button", { type: "submit", children: "Save" }) })] }) })] }));
};
